<template>
  <span @click="download" class="text-prim-grad-1 fw-bolder point underlined"
    >Stampa informativa</span
  >
</template>
<script>
import { utilityService } from "@/_services";
import { mapState, mapActions } from "vuex";
export default {
  name: "DownloadSurveyInfo",
  props: ["survey"],
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
  },
  methods: {
    download() {
      const fName = `informativa_${this.survey.name}.pdf`;
      const self = this;
      utilityService
        .downloadSurveyInfo(this.survey.hashid)
        .then(function (response) {
          let blob = new Blob([response.data]);
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fName;
          link.click();
        })
        .catch(function (err) {
          var msg = "Non è stato possibile scaricare la risorsa";
          if (err.status === 404) {
            msg = "Risorsa non trovata o non accessibile.";
          }
          console.log(err);
          self.errorAlert(msg);
        });
    },
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
  },
};
</script>
